import React, {useContext, useEffect, useState} from "react";
import api from "../../../services/api";
import {MainContext} from "../../../context/MainContext";
import {dateMountString} from "../../../assets/js/helper";

export default function PresenceReport({ filtro, modelo= 'default' }:any) {
    const [athletes, setAthletes] = useState<any>([])
    const [loading, setLoading] = useState<any>(true)

    const {club} = useContext(MainContext)

    async function getAthletes() {
        await api.post(`/api/app/presence/report`, {filtro}).then((response) => {
            setAthletes(response.data)
        }).then(() => {
            setLoading(false)
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            await getAthletes()
        };

        fetchData()
    }, [])

    return (
        <>
            {!loading &&
                <>
                    {modelo == 'default' ? (
                        <div className={'printTable'}>
                            <p style={{textAlign: 'center'}}>&nbsp;</p>
                            <p style={{textAlign: 'center'}}><span
                                style={{fontSize: 'large'}}><strong>Relatório de Presenças</strong></span>
                            </p>

                            <p>
                                <span style={{fontSize: 'large'}}><strong>Dados do Clube de Tiro:</strong></span>
                            </p>

                            <table style={{marginLeft: 'auto', marginRight: 'auto', width: '100%'}}>
                                <tbody>
                                <tr>
                                    <td>NOME</td>
                                    <td style={{textAlign: 'center'}}>
                                        {club?.fantasia}
                                    </td>
                                    <td>
                                        CNPJ: {club?.cnpj}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="270">
                                        CERTIFICADO DE REGISTRO
                                    </td>
                                    <td style={{textAlign: 'center'}}>
                                        {club?.cr_number}
                                    </td>
                                    <td width="400">
                                        DATA VAL: {new Date(club?.cr_validity_date).toLocaleString('pt-BR').substr(0, 10)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>ENDEREÇO</td>
                                    <td>  {club?.address?.street}, {club?.address?.number}, {club?.address?.district} </td>
                                    <td> {club?.address?.city?.name} - {club?.address?.city?.state?.abbreviation} </td>
                                </tr>

                                </tbody>
                            </table>

                            <p style={{textAlign: 'center'}}>&nbsp;</p>

                            <table style={{
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                width: '100%'
                            }} className={'table'}>
                                <tbody>
                                <tr>
                                    <td style={{textAlign: 'center'}} width="230"> Data</td>
                                    <td width="500">Nome</td>
                                    <td width="200">CPF</td>
                                    <td width="200">CR</td>
                                    <td width="100">Qtd. Tiros</td>
                                </tr>

                                {athletes.map((athlete: any, index: number) =>
                                    <tr key={`${index}`}>
                                        <td style={{textAlign: 'center'}}>{athlete?.capture_timestamp ? new Date(athlete?.capture_timestamp).toLocaleString('pt-BR') : ''}</td>
                                        <td>{athlete?.athlete?.full_name}</td>
                                        <td>{athlete?.athlete.cpf}</td>
                                        <td>{athlete?.athlete.cr_number}</td>
                                        <td style={{textAlign: 'center',backgroundColor: athlete?.quantity_shots == 0 ? 'yellow' : 'transparent'}}>{athlete?.quantity_shots}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>

                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <p style={{textAlign: 'center'}}><span style={{fontSize: 'large'}}>_________________________</span>
                            </p>
                            <p style={{textAlign: 'center'}}><span style={{fontSize: 'large'}}>{club?.president_name}</span></p>
                            <p style={{textAlign: 'center'}}><span style={{fontSize: 'large'}}>CPF: {club?.president_cpf}</span>
                            </p>
                            <p style={{textAlign: 'center'}}><span style={{fontSize: 'large'}}>Presidente do Clube de Tiro Caça e Pesca Tapejara – RS</span>
                            </p>
                            <p style={{textAlign: 'center'}}>
                                <span style={{fontSize: 'large'}}>TAPEJARA, {dateMountString(new Date())}.</span>
                            </p>
                            <p>&nbsp;</p>
                        </div>) : (
                        <div className={'printTable'}>
                            <p style={{textAlign: 'center'}}>&nbsp;</p>

                            <table style={{
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                width: '100%'
                            }} className={'table'}>
                                <tbody>
                                <tr>
                                    <td colSpan={7} style={{textAlign: 'center',backgroundColor:  'yellow',fontWeight: 'bold'}}>
                                        Relação dos Atiradores e dos Atletas que Frequentaram Entidades de Tiro Desportivo - OM: {club?.fantasia}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="500" style={{fontWeight: 'bold'}} >Nome da entidade</td>
                                    <td width="200" style={{fontWeight: 'bold'}} >CR entidade</td>
                                    <td width="500" style={{fontWeight: 'bold'}} >Nome</td>
                                    <td width="200" style={{fontWeight: 'bold'}} >CPF</td>
                                    <td width="200" style={{fontWeight: 'bold'}} >CR</td>
                                    <td width="150" style={{fontWeight: 'bold'}} >Qtd. Tiros</td>
                                    <td style={{textAlign: 'center', fontWeight: 'bold'}} width="230"> Data</td>
                                </tr>

                                {athletes.map((athlete: any, index: number) =>
                                    <tr key={`${index}`}>
                                        <td>{club?.fantasia}</td>
                                        <td>{club?.cr_number}</td>
                                        <td>{athlete?.athlete?.full_name}</td>
                                        <td>{athlete?.athlete.cpf}</td>
                                        <td>{athlete?.athlete.cr_number}</td>
                                        <td style={{textAlign: 'center',backgroundColor: athlete?.quantity_shots == 0 ? 'yellow' : 'transparent'}}>{athlete?.quantity_shots}</td>
                                        <td style={{textAlign: 'center'}}>{athlete?.capture_timestamp ? new Date(athlete?.capture_timestamp).toLocaleString('pt-BR') : ''}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                            <p>&nbsp;</p>
                        </div>)}
                </>
            }
        </>
    )
}
